// TickerCard.tsx
// Copyright (c) 2020 Neomantra Corp

import React, { useState } from 'react'
import { Icon, Pane, Button, Badge, Text, Switch, Spinner } from 'evergreen-ui'
import { useSelector, useDispatch } from 'react-redux'
import TickerCardTable from './TickerCardTable'
import TickerCardChart from './TickerCardChart'
import { removeCard } from '../toolBar/toolBarSlice'
import { exportCardToFile } from '../cardGrid/cardSlice'
import { RootState } from '../../app/rootReducer'

type TickerCardProps = {
    index: number
}

const TickerCard = ({ index }: TickerCardProps) => {
    const cardStackData = useSelector((state: RootState) => state.console.cardStack),
        loading = useSelector((state: RootState) => state.card.loading),
        dispatch = useDispatch(),
        [showChart, setShowChart] = useState(true)

    const cardData = cardStackData[index],
        exchange = cardData && cardData.channel.split('/')[1],
        cross = cardData && cardData.channel.split('/')[2],
        ticker = cardData && cardData.channel.split('/')[3],
        data = cardData && cardData.data,
        dataLength = data && data.length

    return (
        <div style={{ background: '#green', width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
            <div style={{ background: '#e9e9e9', margin: '-1', display: 'flex' }}>
                <Pane flex={8} cursor='move' padding={8} display='flex'>
                    <Text marginLeft={4} marginTop={-1} fontSize={14} fontWeight={700} color='#444'>
                        {ticker}
                    </Text>
                    {cross === 'imbO' ? (
                        <Badge marginTop={1} marginLeft={12} color='green'>
                            Open
                        </Badge>
                    ) : (
                        <Badge marginTop={1} marginLeft={12} color='yellow'>
                            Close
                        </Badge>
                    )}
                    {exchange === 'nyse' ? (
                        <Badge marginTop={1} marginLeft={12} color='teal'>
                            NYSE
                        </Badge>
                    ) : (
                        <Badge marginTop={1} marginLeft={12} color='blue'>
                            NASDAQ
                        </Badge>
                    )}
                    <Pane flex={2} display='flex'>
                        <Icon marginLeft={12} marginTop={1} color='#aaa' icon={'timeline-line-chart'} size={16} />
                        <Switch marginLeft={8} marginTop={0} checked={showChart} onChange={(e) => setShowChart(e.target.checked)} />
                    </Pane>
                    {loading && <Spinner size={16} marginRight={5} />}
                    <Button marginTop={-2} marginLeft={1} onClick={() => dispatch(exportCardToFile(cardData))} appearance='minimal' height={20} iconBefore='download'>
                        Save
                    </Button>
                    <Button marginTop={-2} marginLeft={1} onClick={() => dispatch(removeCard(index))} appearance='minimal' height={20} iconBefore='delete'>
                        Remove
                    </Button>
                </Pane>
            </div>
            <div style={{ background: '#e9e9e9', width: '100%', height: '100%', margin: '0', padding: '0' }}>
                <TickerCardTable index={index} />
            </div>
            {showChart && (
                <div style={{ background: '#e9e9e9', margin: '0', padding: '10', paddingTop: '0', paddingBottom: '20' }}>
                    <TickerCardChart data={data} />
                </div>
            )}
        </div>
    )
}

export default TickerCard
